
  import Navbar from "@/components/navbar.vue";
  import Foot from "@/components/foot.vue";
  export default {
    components: { Foot, Navbar },
  };
